    import React, { createContext, useState, useContext, useEffect } from 'react';
    import { useUser } from './userContext';

    const SimulatorContext = createContext(null);

    export const SimulatorProvider = ({ children }) => {

      const { userId } = useUser();

      const [recordId, setRecordId] = useState(( ) => {
        let xRecordId = null;
        if (sessionStorage.getItem('recordId') !== 'undefined') {
          xRecordId = sessionStorage.getItem('recordId');
        }
        return xRecordId ? JSON.parse(xRecordId) : null;
      });

      const [simulatorId, setSimulatorId] = useState(( ) => {
        let xSimulatorId = null;
        if (sessionStorage.getItem('simulatorId') !== 'undefined') {
          xSimulatorId = sessionStorage.getItem('simulatorId');
        }
        return xSimulatorId ? JSON.parse(xSimulatorId) : null;
      });

      const [simulator, setSimulator] = useState(( ) => {
        let xSimulator = null;
        if (sessionStorage.getItem('simulator') !== 'undefined') {
          xSimulator = sessionStorage.getItem('simulator');
        }
        return xSimulator ? JSON.parse(xSimulator) : null;
      });

      const [executed, setExecuted] = useState(( ) => {
        let xExecuted = null;
        if (sessionStorage.getItem('executed') !== 'undefined') {
          sessionStorage.getItem('executed');
        }
        return xExecuted ? JSON.parse(xExecuted) : null;
      });

      useEffect(() => {
        sessionStorage.setItem('recordId', JSON.stringify(recordId));
      }, [recordId]);

      useEffect(() => {
        sessionStorage.setItem('simulatorId', JSON.stringify(simulatorId));
      }, [simulatorId]);

      useEffect(() => {
        sessionStorage.setItem('simulator', JSON.stringify(simulator));
      }, [simulator]);

      useEffect(() => {
        sessionStorage.setItem('executed', JSON.stringify(executed));
      }, [executed]);

      const updateRecordId = (id) => {
        setRecordId(id);
      };

      const updateSimulatorId = (id) => {
        setSimulatorId(id);
      };

      const updateSimulator = (simulator) => {
        setSimulator(simulator);
      };

      const updateExecuted = (executed) => {
        setExecuted(executed);
      };

      const removeApplicationRecordsByUserId = async (user_id) => {
          try {  
              const response = await fetch(`${process.env.REACT_APP_API}/applications/user_id/${user_id}`, {
                method: 'DELETE',
                headers: {
                  'Content-Type': 'application/json',
                }
              })
          } catch (error) {}
      }

      const removeSimulatorData = () => {

        const simId = sessionStorage.getItem('simulatorId');
        const userId = sessionStorage.getItem('userId');

        if ( simId !== 'undefined') {
            removeApplicationRecordsByUserId(userId);
        }
      }

      const simulatorLogout = async() => {
        await removeSimulatorData();
        setRecordId(null);
        setSimulatorId(null);
        setSimulator(null);
        setExecuted(null);
      }

      return (
        <SimulatorContext.Provider 
            value={{ 
                recordId, simulatorId, simulator, executed, simulatorLogout, updateRecordId, updateSimulatorId, updateSimulator, updateExecuted 
            }}
        >
            {children}
        </SimulatorContext.Provider>
      );
    };

    export const useSimulator = () => useContext(SimulatorContext);